"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _wcagElementContrast = _interopRequireDefault(require("wcag-element-contrast"));

var _uiForms = require("@instructure/ui-forms");

var _uiLayout = require("@instructure/ui-layout");

var _colorPicker = _interopRequireDefault(require("./color-picker"));

class ColorField extends _react.default.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      width: 200
    };

    this.handlePickerChange = color => {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: ColorField.stringifyRGBA(color.rgb)
        }
      });
    };
  }

  static stringifyRGBA(rgba) {
    if (rgba.a === 1) {
      return `rgb(${rgba.r}, ${rgba.g}, ${rgba.b})`;
    }

    return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
  }

  componentDidMount() {
    this.setState({
      width: _reactDom.default.findDOMNode(this).offsetWidth
    });
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_uiLayout.View, {
      as: "div"
    }, /*#__PURE__*/_react.default.createElement(_uiForms.TextInput, this.props), /*#__PURE__*/_react.default.createElement(_colorPicker.default, {
      color: _wcagElementContrast.default.parseRGBA(this.props.value),
      onChange: this.handlePickerChange
    }));
  }

}

exports.default = ColorField;